import { InputHTMLAttributes } from 'react';
import { ReactComponent as CheckboxIcon } from '../../icons/checkbox-checked.svg';
import { ReactComponent as EmptyCheckboxIcon } from '../../icons/checkbox-unchecked.svg';
import {
  CheckboxContainer,
  HiddenCheckbox,
  IconWrapper,
} from './Checkbox.styles';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  /**
   * If a label is rendered elsewhere, provide the element's ID here
   * to create the association for accessibility
   */
  labelId?: string;
}

export const Checkbox = ({
  checked,
  labelId,
  ...rest
}: CheckboxProps): JSX.Element => {
  const inputProps: InputHTMLAttributes<HTMLInputElement> = {
    type: 'checkbox',
    checked,
    ...rest,
  };

  // Add aria-labelledby if a labelId is provided
  if (labelId) {
    inputProps['aria-labelledby'] = labelId;
  }

  return (
    <CheckboxContainer>
      <HiddenCheckbox data-testid="hidden-checkbox" {...inputProps} />
      <IconWrapper>
        {checked ? <CheckboxIcon /> : <EmptyCheckboxIcon />}
      </IconWrapper>
    </CheckboxContainer>
  );
};
